import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { UncontrolledCollapse, UncontrolledTooltip } from 'reactstrap';
import Icon from '../../components/Icon/Icon';
import { currencyToSign } from '../../utils/utils';
import Card from '../Card/Card';

const LIMIT = 10;

const PixelGroupList = (props) => {
  let { pixels, offer_geo, countries, geos, id, isGambling, isCdn } = props;
  const [showMainDropdown, setShowMainDropdown] = useState(false);
  const [showDeclinesDropdown, setShowDeclinesDropdown] = useState(false);

  const toggleMain = () => {
    setShowMainDropdown((prev) => !prev);
  };

  const toggleDeclines = () => {
    setShowDeclinesDropdown((prev) => !prev);
  };

  const getPayout = (p) => {
    return p.text_summ
      ? p.text_summ
      : `${p.summ} ${p.isPercent ? '%' : currencyToSign(p.currency)}`;
  };

  const getPrice = (p) => {
    const { geo } = p;
    if (!offer_geo.prices[geo]) return '';
    return `${offer_geo.prices[geo].price} ${offer_geo.prices[geo].currency}`;
  };

  const getCountry = (p) =>
    p.geo ? Array.isArray(countries) && countries.find((c) => c.id === p.geo)?.title : p.title; // p.title заглушка

  const checkIsConfirmedDecline = (pixel) =>
    pixel.group_name === 'Подтверждение отмены' || pixel.group_name === 'Confirmed decline';

  const renderLinks = () => (
    <div className="links">
      <Link to={`/tickets/create?theme=geoRequest&offer=${id}`}>
        <FormattedMessage id="offer.buttons.geo-request" defaultMessage="Not enough wide GEO?" />
      </Link>
      <Link to={`/tickets/create?theme=pixelRequest&offer=${id}`}>
        <FormattedMessage
          id="offer.buttons.pixels-request"
          defaultMessage="Did you find a higher payout?"
        />
      </Link>
    </div>
  );

  const renderShowAllMainButton = () => (
    <div className="btn-action">
      <button
        id="pixels-show-btn"
        type="button"
        className="btn btn-primary no-focus"
        onClick={toggleMain}
      >
        {showMainDropdown ? (
          <FormattedMessage id="main.hide" defaultMessage="Hide" />
        ) : (
          <FormattedMessage id="offer.geo.show-all" defaultMessage="All Countries">
            {(message) => (geos.length ? `${message} (${geos.length})` : message)}
          </FormattedMessage>
        )}
      </button>
    </div>
  );

  const renderShowAllDeclineButton = () => (
    <div className="btn-action">
      <button
        id="pixels-show-btn2"
        type="button"
        className="btn btn-primary no-focus"
        onClick={toggleDeclines}
      >
        {showDeclinesDropdown ? (
          <FormattedMessage id="main.hide" defaultMessage="Hide" />
        ) : (
          <FormattedMessage id="offer.geo.show-all" defaultMessage="All Countries">
            {(message) => (pixels.length ? `${message} (${pixels.length})` : message)}
          </FormattedMessage>
        )}
      </button>
    </div>
  );

  const sortPixelsBySumm = (a, b) => {
    if (a.isPercent && b.isPercent) return parseInt(b.summ, 10) - parseInt(a.summ, 10);
    else if (a.isPercent && !b.isPercent) return -1;
    else if (!a.isPercent && b.isPercent) return 1;
    else return b.summ - a.summ;
  };

  const PRODUCT_OFFER = offer_geo.prices && !Array.isArray(offer_geo.prices);

  if (PRODUCT_OFFER) {
    // делим на 2 массива - основные цели и отмена
    const mainPixels = [];
    const declinePixels = [];
    for (let pixel of pixels) {
      if (checkIsConfirmedDecline(pixel)) {
        declinePixels.push(pixel);
      } else {
        mainPixels.push(pixel);
      }
    }
    let hasConfirmedDeclinePixel = declinePixels.length > 0;
    // const sortPixels = [...pixels].sort(sortPixelsBySumm)
    const mapPixels = mainPixels.map((p) => {
      return (
        <div className="price-items" key={p.id}>
          <span className="geo">{getCountry(p)}</span>
          <span className="pixel">{getPrice(p)}</span>
          <span className="rate">
            {p.device && p.device.includes('mobile') && (
              <>
                <Icon type="mobile" className="mr-1" id={`mobile-icon-${p.id}`} />
                <UncontrolledTooltip placement="left" target={`mobile-icon-${p.id}`}>
                  <FormattedMessage
                    id="offer.pixels.device.mobile-tooltip"
                    defaultMessage="Mobile"
                  />
                </UncontrolledTooltip>
              </>
            )}
            {p.device && p.device.includes('desktop') && (
              <>
                <Icon type="monitor" className="mr-1" id={`desktop-icon-${p.id}`} />
                <UncontrolledTooltip placement="left" target={`desktop-icon-${p.id}`}>
                  <FormattedMessage
                    id="offer.pixels.device.desktop-tooltip"
                    defaultMessage="Desktop"
                  />
                </UncontrolledTooltip>
              </>
            )}

            {p.icons.crown && (
              <>
                <Icon id={`payout-crown-${p.id}`} type="crown" className="mr-1" />
                <UncontrolledTooltip target={`payout-crown-${p.id}`}>
                  <FormattedMessage
                    id="offer.geo_bonus_crown.tooltip.text"
                    defaultMessage="Payout"
                  />
                </UncontrolledTooltip>
              </>
            )}
            {getPayout(p)}
          </span>
        </div>
      );
    });

    const mapDeclinePixels = declinePixels.map((p) => {
      return (
        <div className="price-items" key={p.id}>
          <span className="geo">{getCountry(p)}</span>
          <span className="pixel"></span>
          <span className="rate">
            {p.device && p.device.includes('mobile') && (
              <>
                <Icon type="mobile" className="mr-1" id={`mobile-icon-${p.id}`} />
                <UncontrolledTooltip placement="left" target={`mobile-icon-${p.id}`}>
                  <FormattedMessage
                    id="offer.pixels.device.mobile-tooltip"
                    defaultMessage="Mobile"
                  />
                </UncontrolledTooltip>
              </>
            )}
            {p.device && p.device.includes('desktop') && (
              <>
                <Icon type="monitor" className="mr-1" id={`desktop-icon-${p.id}`} />
                <UncontrolledTooltip placement="left" target={`desktop-icon-${p.id}`}>
                  <FormattedMessage
                    id="offer.pixels.device.desktop-tooltip"
                    defaultMessage="Desktop"
                  />
                </UncontrolledTooltip>
              </>
            )}

            {p.icons.crown && (
              <>
                <Icon id={`payout-crown-${p.id}`} type="crown" className="mr-1" />
                <UncontrolledTooltip target={`payout-crown-${p.id}`}>
                  <FormattedMessage
                    id="offer.geo_bonus_crown.tooltip.text"
                    defaultMessage="Payout"
                  />
                </UncontrolledTooltip>
              </>
            )}
            {getPayout(p)}
          </span>
        </div>
      );
    });

    return (
      <>
        <div className="offer-terms">
          <div className="terms">
            <span>
              <FormattedMessage id="offer.pixels.target" defaultMessage="Target" />
            </span>
            {pixels.find((p) => !checkIsConfirmedDecline(p))?.group_name || pixels[0].title}
          </div>
          <div className="prices">
            <div className="price-titles">
              <span className="geo">
                <FormattedMessage id="offer.pixels.goe" defaultMessage="Geo" />
              </span>
              <span className="pixel">
                <FormattedMessage id="offer.pixels.price" defaultMessage="Price" />
              </span>
              <span className="rate">
                <FormattedMessage id="offer.pixels.payout" defaultMessage="Payout" />
              </span>
            </div>
            {mapPixels.slice(0, LIMIT)}
            {mapPixels.length > LIMIT && (
              <UncontrolledCollapse toggler="pixels-show-btn">
                {mapPixels.slice(LIMIT)}
              </UncontrolledCollapse>
            )}
          </div>
          {/* {!hasConfirmedDeclinePixel ? renderLinks() : null} */}
          {mapPixels.length > LIMIT && renderShowAllMainButton()}
        </div>

        {hasConfirmedDeclinePixel ? (
          <div className="offer-terms">
            <div className="terms">
              <span>
                <FormattedMessage id="offer.pixels.target" defaultMessage="Target" />
              </span>
              <span>
                <FormattedMessage
                  id="offer.pixels.target-decline"
                  defaultMessage="Confirmed decline"
                />{' '}
                <i
                  className="icon-help-question offer-terms-tooltip-icon"
                  id="offer-terms-tooltip-icon"
                />
              </span>
              <UncontrolledTooltip target="offer-terms-tooltip-icon">
                <FormattedMessage
                  id="offer.pixels.tooltip.target-decline"
                  defaultMessage="Terms of payment for leads in cancellation, confirmed when re-processing by Call-center"
                />
              </UncontrolledTooltip>
            </div>
            <div className="prices">
              <div className="price-titles">
                <span className="geo">
                  <FormattedMessage id="offer.pixels.goe" defaultMessage="Geo" />
                </span>
                <span className="pixel"></span>
                <span className="rate">
                  <FormattedMessage id="offer.pixels.payout" defaultMessage="Payout" />
                </span>
              </div>
              {mapDeclinePixels.slice(0, LIMIT)}
              {mapDeclinePixels.length > LIMIT && (
                <UncontrolledCollapse toggler="pixels-show-btn2">
                  {mapDeclinePixels.slice(LIMIT)}
                </UncontrolledCollapse>
              )}
            </div>
            {/* {renderLinks()} */}
            {mapDeclinePixels.length > LIMIT && renderShowAllDeclineButton()}
          </div>
        ) : null}
      </>
    );
  } else {
    // GM  подобные офферы
    // от 1 до 3 целей
    const sortPixels = [...pixels].sort(sortPixelsBySumm);
    const mapPixels = sortPixels.map((p) => {
      const country = p.geo ? (
        getCountry(p)
      ) : (
        <FormattedMessage id="offer.geo-list.all" defaultMessage="The whole world" />
      );
      return (
        <div className="price-items" key={p.id}>
          <span className="geo">{country}</span>
          <span className="pixel">{p.group_name || p.title}</span>
          <span className="rate">
            {p.icons.crown && (
              <>
                <Icon id={`payout-crown-${p.id}`} type="crown" className="mr-1" />
                <UncontrolledTooltip target={`payout-crown-${p.id}`}>
                  <FormattedMessage
                    id="offer.geo_bonus_crown.tooltip.text"
                    defaultMessage="Payout"
                  />
                </UncontrolledTooltip>
              </>
            )}
            {getPayout(p)}
          </span>
        </div>
      );
    });
    return (
      <div className="offer-terms">
        <div className="prices">
          <div className="price-titles">
            <span className="geo">
              <FormattedMessage id="offer.pixels.goe" defaultMessage="Geo" />
            </span>
            <span className="pixel">
              <FormattedMessage id="offer.pixels.target" defaultMessage="Terget" />
            </span>
            <span className="rate">
              <FormattedMessage id="offer.pixels.payout" defaultMessage="Payout" />
            </span>
          </div>
          {mapPixels.slice(0, LIMIT)}
          {mapPixels.length > LIMIT && (
            <UncontrolledCollapse toggler="pixels-show-btn">
              {mapPixels.slice(LIMIT)}
            </UncontrolledCollapse>
          )}
        </div>
        {/* {!isGambling && renderLinks()} */}
        {mapPixels.length > LIMIT && renderShowAllMainButton()}
      </div>
    );
  }
};

export default PixelGroupList;
